import React, { useState, useEffect } from "react";
import axios from "axios";

function QueryHistory({ getNavProps, sendErrorToServer, audioData }) {
  const [history, setHistory] = useState([]);
  const [expandedIndices, setExpandedIndices] = useState(new Set());
  const [showPromptTranslation, setShowPromptTranslation] = useState(new Set());
  const [showResponseTranslation, setShowResponseTranslation] = useState(
    new Set()
  );

  const fetchGuestQueryHistory = async () => {
    try {
      const navProps = getNavProps();
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/query-history`,
        navProps
      );
      setHistory(response.data);
    } catch (error) {
      await sendErrorToServer(error);
      console.error("Error fetching request stats: ", error);
    }
  };

  const toggleExpand = (index) => {
    const newSet = new Set(expandedIndices);
    if (newSet.has(index)) {
      newSet.delete(index);
    } else {
      newSet.add(index);
    }
    setExpandedIndices(newSet);
  };

  const togglePromptTranslation = (index) => {
    const newSet = new Set(showPromptTranslation);
    if (newSet.has(index)) {
      newSet.delete(index);
    } else {
      newSet.add(index);
    }
    setShowPromptTranslation(newSet);
  };

  const toggleResponseTranslation = (index) => {
    const newSet = new Set(showResponseTranslation);
    if (newSet.has(index)) {
      newSet.delete(index);
    } else {
      newSet.add(index);
    }
    setShowResponseTranslation(newSet);
  };

  useEffect(() => {
    fetchGuestQueryHistory();
  }, [audioData]);

  return history.length > 0 ? (
    <div className="query-history-container">
      {/* <h2>Question History</h2> */}
      <ul>
        {history.map((item, index) => (
          <li key={index}>
            <strong>Prompt:</strong>"
            {item.language === "ml-IN" && showPromptTranslation.has(index)
              ? item.translation
              : item.transcript}
            "
            {item.language === "ml-IN" && (
              <button onClick={() => togglePromptTranslation(index)}>
                {showPromptTranslation.has(index)
                  ? "Show Original"
                  : "Translate"}
              </button>
            )}
            <br />
            <br />
            <strong>ChatGPT:</strong>{" "}
            {(item.language === "ml-IN" && showResponseTranslation.has(index)
              ? item.gpt_response_translation
              : item.gpt_response
            ).length > 150 && !expandedIndices.has(index)
              ? (item.language === "ml-IN" && showResponseTranslation.has(index)
                  ? item.gpt_response_translation
                  : item.gpt_response
                ).substring(0, 150) + "..."
              : item.language === "ml-IN" && showResponseTranslation.has(index)
              ? item.gpt_response_translation
              : item.gpt_response}
            {item.gpt_response.length > 150 && (
              <button onClick={() => toggleExpand(index)}>
                {expandedIndices.has(index) ? "See Less" : "See More"}
              </button>
            )}
            {item.language === "ml-IN" && (
              <button onClick={() => toggleResponseTranslation(index)}>
                {showResponseTranslation.has(index)
                  ? "Show Original"
                  : "Translate"}
              </button>
            )}
          </li>
        ))}
      </ul>
    </div>
  ) : null;
}

export default QueryHistory;
